<template>
    <page-layout>
        <template #header>
            <page-title title="Activation links" @on-close="handleClose" />
        </template>
        <g-loader v-if="isLoading" type="fixed" />
        <template v-else>
            <div v-if="canCreateDeepLink()">
                <g-typography font-weight="semibold" value="Create links" />
                <g-typography tag="p" class="margin-bottom-large">
                    Paste a product or collection's link to create a your own unique link. Don't paste links from ads or
                    emails.
                </g-typography>

                <g-form @submit.prevent="handleSubmit">
                    <g-form-item class="pt-10 pb-15 mb-0">
                        <g-input
                            v-model="url"
                            placeholder="https://www.store.com/producturl"
                            size="large"
                            data-testid="link-input"
                            :disabled="isLoading"
                        />
                    </g-form-item>
                    <g-button
                        block
                        theme="live"
                        shape="round"
                        size="large"
                        type="primary"
                        html-type="submit"
                        :disabled="isLoading"
                        data-testid="add-link-button"
                    >
                        Create link
                    </g-button>
                </g-form>
                <g-divider class="mt-40 mb-40" />
            </div>
            <affiliate-links-display :affiliate-links="affiliateLinks" :is-loading="isLoading" />
        </template>
    </page-layout>
</template>

<script>
    import PageLayout from '../../layouts/PageLayout.vue';
    import PageTitle from '../../library/PageTitle.vue';
    import useRouter from '../../../../src/composables/use-router';
    import AffiliateLinksDisplay from './partials/AffiliateLinksDisplay.vue';
    import { computed, ref } from 'vue-demi';
    import useMessage from '../../../../src/composables/use-message';

    export default {
        name: 'ActivationBriefAffiliateLinksView',
        components: {
            PageTitle,
            PageLayout,
            AffiliateLinksDisplay
        },
        props: {
            affiliateLinks: {
                type: Array,
                default: () => []
            },
            isLoading: {
                type: Boolean,
                default: false
            },
            canCreateDeepLink: {
                type: Function,
                required: true
            }
        },
        setup(props, { emit }) {
            const url = ref(null);
            const router = useRouter().get();
            const { message } = useMessage();
            const handleClose = () => {
                router.push({ name: 'v2.activation.brief.overview' });
            };

            const parentLink = computed(() => {
                return props.affiliateLinks.find((link) => link.parent_contact_link_id === null) || '';
            });

            const handleSubmit = () => {
                if (!url.value) {
                    message.error('Copy and paste a link.');
                    return;
                }
                emit('create-deep-link', parentLink.value.link_id, parentLink.value.id, url.value);
                url.value = null;
            };

            return {
                url,
                handleClose,
                handleSubmit
            };
        }
    };
</script>

<style scoped lang="scss"></style>
